import styles from "./BankCardHeader.module.scss";
import MainButton from "../../../../shared/button/MainButton";
import { BankCardsPageData } from "../../../../../pages/admin-panels/bank-cards/BankCards";

interface BankCardHeaderProps {
  pageData: BankCardsPageData;
  onAddCard: () => void;
  isLoading?: boolean;
  translationData: any;
}

const BankCardHeader = ({
  pageData,
  onAddCard,
  isLoading = false,
  translationData,
}: BankCardHeaderProps) => {
  return (
    <div className={styles.header_container}>
      <div className={styles.header_content}>
        <h2 className={styles.title}>
          {translationData?.auth_bank_cards || "Bank Kartlarım"}
        </h2>
        <p className={styles.subtitle}>
          {translationData?.auth_bank_cards_subtitle ||
            "Kartlarınızı əlavə edin və idarə edin"}
        </p>
      </div>
      <div className={styles.add_button}>
        <MainButton
          text={pageData?.add_card_btn || translationData?.auth_add_card || "Kart əlavə et"}
          onClick={onAddCard}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default BankCardHeader;
